import type { Model } from './store/slices/modelSlice';
// 配置类型定义
export interface AppConfig {
  // 模型配置
  model: {
    defaultModel: string;
  };
  // 主题配置
  theme: 'light' | 'dark' | 'system';
  // 主题色
  accentColor: 'blue' | 'indigo' | 'cyan' | 'green' | 'orange' | 'pink' | 'purple' | 'red';
  // 语言配置
  language: 'zh' | 'zh-TW' | 'en';
  // 语言初始化标记 (用于判断是否是首次启动)
  language_initialized?: boolean;
  // 镜像源选择 (type -> mirror_id)
  registryMirrors?: Record<string, string>;
  // 镜像源 URL (type -> url)，后端直接使用
  registryMirrorUrls?: Record<string, string>;
  // 系统代理
  useSystemProxy?: boolean;
  // 对话辅助提示（LLM 生成后续建议）
  quickActionSuggestionsEnabled?: boolean;
  // 应用配置
  app: {
    port: number;
    isDevelopment: boolean;
  };
  // 模型提供商配置（由 authService.fetchAndSaveBoBotModels 写入）
  providers?: Record<string, {
    enabled: boolean;
    apiKey: string;
    baseUrl: string;
    apiFormat?: string;
    models: Model[];
  }>;
  // 快捷键配置
  shortcuts?: {
    newChat: string;
    search: string;
    settings: string;
    [key: string]: string | undefined;
  };
}

// 默认配置
export const defaultConfig: AppConfig = {
  model: {
    defaultModel: '',
  },
  theme: 'system',
  accentColor: 'blue',
  language: 'zh',
  app: {
    port: 4000,
    isDevelopment: process.env.NODE_ENV === 'development',
  },
  shortcuts: {
    newChat: 'Ctrl+N',
    search: 'Ctrl+F',
    settings: 'Ctrl+,',
  }
};

// 配置存储键
export const CONFIG_KEYS = {
  APP_CONFIG: 'app_config',
  AUTH: 'auth_state',
  CONVERSATIONS: 'conversations',
  SKILLS: 'skills',
};
